export default __webpack_public_path__ + "static/media/online.9ddaa722.svg";